<template>
    <div class="current_image">
        <a aria-label="View Product Image" target="_blank" v-bind:href="url">
            <img alt="Product Image" v-bind:src="url">
        </a>
        <a @click="deleteImage($event)" class="text-danger delete_image" href="#">Delete</a>
    </div>
</template>

<script>
    export default {
        props: ['id', 'productId', 'ajax', 'url'],

        mounted() {
            // console.log('Component mounted.')
        },

        data: function () {
            return {}
        },

        methods: {
            deleteImage(event) {
                event.preventDefault();

                let productImage = this, $this = $(event.target);

                if (!$this.hasClass('disabled')) {

                    $this.toggleClass('disabled', true);

                    let dialog = bootbox.dialog({
                        title: "Delete Image?",
                        message: "This image will not be able to be restored.",
                        buttons: {
                            cancel: {
                                label: '<i class="fa fa-times"></i> Cancel',
                                callback: function () {
                                    //
                                }
                            },
                            confirm: {
                                label: '<i class="fa fa-check"></i> Confirm',
                                className: 'btn-danger',
                                callback: function () {
                                    dialog.find('.modal-footer').remove();

                                    dialog.find('.bootbox-body').html('<p><i class="fa fa-spin fa-spinner"></i> Please wait...</p>');

                                    axios.post(productImage.ajax, {
                                        id: productImage.id,
                                        productId: productImage.productId
                                    })
                                        .then(response => {
                                            if (response.data.response == 'ok') {

                                                dialog.find('.bootbox-body').html('<p>Image Deleted!</p>');

                                                $this.parents('.current_image').remove();

                                            } else {

                                                $this.toggleClass('disabled', false);

                                                dialog.find('.bootbox-body').html('<p>Image could not be deleted!</p>');
                                            }

                                            setTimeout(function () {
                                                dialog.modal('hide');
                                            }, 500);
                                        })
                                        .catch(errors => {
                                            console.log(errors);

                                            $this.toggleClass('disabled', false);

                                            dialog.find('.bootbox-body').html('<p>Image could not be deleted!</p>');

                                            setTimeout(function () {
                                                dialog.modal('hide');
                                            }, 500);
                                        });

                                    return false;
                                }
                            }
                        }
                    });

                }
            },
        }
    }
</script>
